var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"window-height window-width row justify-center items-center"},[_c('q-spinner',{attrs:{"color":"light-blue","size":"4rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }